import React, { useEffect, useState } from 'react';
import {
  COPYWRIGHT_TEXT,
  FOOTER_LINK_1,
  FOOTER_LINK_2,
  FOOTER_LINK_3,
} from '../constants/constant';
import commonService from 'src/services/commonService';

interface ProjectVersionResponse {
  version: string;
}

function Footer(): JSX.Element {
  const [PROJECT_VERSION, setprojectVersion] = useState<string>('');

  useEffect(() => {
    commonService.getProjectVersion()
      .then((res: { data: ProjectVersionResponse }) => {
        setprojectVersion(`Version: ${res.data.version}`);
      })
      .catch(error => {
        console.error("Error fetching project version:", error);
      });
  }, []);

  return (
    <footer
      className="footer bg-white px-10 py-4"
      style={{ bottom: 0, width: '100%' }}
    >
      <div className="flex justify-between items-center w-full">
        {/* Left-aligned: Copywrite Text */}
        <div className="flex justify-start sm:justify-center items-center">
          <p className="text-muted2 text-12 ml-[-40px]">{COPYWRIGHT_TEXT}</p>
        </div>

        {/* Center-aligned: Project Version */}
        <div className="flex justify-center items-center">
          <p className="text-muted2 text-12">{PROJECT_VERSION}</p>
        </div>

        {/* Right-aligned: Footer Links */}
        <nav className="flex justify-end">
          <a
            href="https://www.healthlinkdimensions.com/website-terms"
            target="_blank"
            className="text-muted2 text-12 hover:text-primary pr-4 border-r border-muted2 pt-0 pb-0"
            rel="noreferrer"
          >
            {FOOTER_LINK_1}
          </a>
          <a
            href="https://www.healthlinkdimensions.com/privacy-policy"
            target="_blank"
            className="text-muted2 text-12 hover:text-primary pr-4 pl-4 border-r border-muted2 pt-0 pb-0"
            rel="noreferrer"
          >
            {FOOTER_LINK_2}
          </a>
          <a
            href="https://www.healthlinkdimensions.com/consumerprivacyrights"
            target="_blank"
            className="text-muted2 text-12 hover:text-primary pl-4"
            rel="noreferrer"
          >
            {FOOTER_LINK_3}
          </a>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
